import React from 'react';
import { withRouter } from 'react-router-dom';

import { CarsSearchPage } from '../cars-search';
import { CarsWrapper } from '@components';

import './style.scss';

interface IProps { }

function CarsPageComponent(props: IProps) {
  return (
    <>
      <CarsSearchPage />;
      {/* <CarsWrapper />; */}
    </>
  )
}

export const CarsPage = withRouter(CarsPageComponent);